import { render, staticRenderFns } from "./landDong.vue?vue&type=template&id=37e79d40&scoped=true"
import script from "./landDong.vue?vue&type=script&lang=js"
export * from "./landDong.vue?vue&type=script&lang=js"
import style0 from "./landDong.vue?vue&type=style&index=0&id=37e79d40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e79d40",
  null
  
)

export default component.exports